/** Admin UI: pass `locale` + `timeZone` from Rails so SSR matches the browser. */
export type AdminTableDateOptions = {
  locale: string;
  timeZone: string;
};

/** Contractor dashboard/billing dates: use Rails `*Display` + `ssrFormattedDateOr` instead. */
export function formatAdminTableDate(
  iso: string,
  { locale, timeZone }: AdminTableDateOptions,
): string {
  return new Date(iso).toLocaleDateString(locale, {
    timeZone,
    year: "numeric",
    month: "short",
    day: "numeric",
  });
}
